// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VS9o","bigColWidth":"Table_bigColWidth__3BFQd","biggerColWidth":"Table_biggerColWidth__cH1PD","row":"Table_row__2RQwS","col":"Table_col__2J_r2"};